import type { MaybeRefOrGetter } from 'vue'

import type { UserProfileOut } from '@/shared/api/intranet'
import { queryKeys } from '@/shared/lib/queryKeys'
import { type UseSelectInfiniteOptions, useSelectInfinite } from '@/shared/lib/useSelectInfinite'

import { listUserProfilesPage } from '../api'

const PAGE_SIZE = 30

const getUserDisplayName = (user: UserProfileOut) => `${user.firstName} ${user.lastName}`.trim()

type UseUsersSelectOptionsConfig = Pick<UseSelectInfiniteOptions<UserProfileOut>, 'searchDebounceMs'>

export const useUsersSelectOptions = (selectedIds: MaybeRefOrGetter<string[]>, config?: UseUsersSelectOptionsConfig) =>
  useSelectInfinite<UserProfileOut>({
    buildQueryKey: (search) => queryKeys.usersSelectProfilesList(search),
    fetchPage: ({ page, search, signal }) =>
      listUserProfilesPage({
        page,
        filter: {
          is_blocked: false,
          query: search,
        },
        signal,
      }).then(({ userProfiles, totalPages }) => ({
        items: userProfiles,
        totalPages,
      })),
    toOption: (user) => ({
      label: getUserDisplayName(user),
      value: user.id,
    }),
    pageSize: PAGE_SIZE,
    selectedIds,
    buildByIdsQueryKey: (ids) => queryKeys.usersSelectProfilesByIds(ids),
    // Без is_blocked: выбранным может оказаться уже заблокированный пользователь — имя всё равно нужно показать
    fetchByIds: async (ids, signal) => {
      const { userProfiles } = await listUserProfilesPage({
        page: {
          number: 1,
          size: ids.length,
        },
        filter: {
          ids,
        },
        signal,
      })

      return userProfiles
    },
    ...config,
  })
